import { render, staticRenderFns } from "./AccountOrganizzatori.vue?vue&type=template&id=c6cdb962&"
import script from "./AccountOrganizzatori.vue?vue&type=script&lang=js&"
export * from "./AccountOrganizzatori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports